import React, { useEffect, useRef, useState } from 'react';
import './TowerJumpNav.css';

// ギルド戦ページ用のタワー素早く移動ナビ。
// towers: 表示中のタワー番号の配列（昇順）。
// idPrefix: セクション id のプレフィックス（ページごとに一意にする）。
const TowerJumpNav = ({ towers, idPrefix = 'tower-section' }) => {
  const [active, setActive] = useState(null);
  const navRef = useRef(null);

  // スクロール位置から現在表示中のタワーを追跡する。
  useEffect(() => {
    if (!towers || !towers.length) return undefined;

    const compute = () => {
      let current = null;
      for (const t of towers) {
        const el = document.getElementById(`${idPrefix}-${t}`);
        if (!el) continue;
        // ナビバーの高さ(約56px)より上に来た最後のタワーを現在地とする。
        if (el.getBoundingClientRect().top <= 140) current = t;
      }
      setActive(current);
    };

    const targets = towers
      .map((t) => document.getElementById(`${idPrefix}-${t}`))
      .filter(Boolean);
    if (!targets.length) return undefined;

    const observer = new IntersectionObserver(compute, {
      rootMargin: '-56px 0px -55% 0px',
      threshold: 0,
    });
    targets.forEach((el) => observer.observe(el));
    compute();

    return () => observer.disconnect();
  }, [towers, idPrefix]);

  // アクティブなボタンが常に視界に入るようナビ内をスクロールする。
  useEffect(() => {
    if (active == null || !navRef.current) return;
    const btn = navRef.current.querySelector(`[data-nav="${active}"]`);
    if (btn) {
      btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [active]);

  const scrollToTower = (t) => {
    const el = document.getElementById(`${idPrefix}-${t}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!towers || !towers.length) return null;

  return (
    <nav className="tower-jump-nav" ref={navRef} aria-label="タワーへ移動">
      <button
        type="button"
        className="tower-jump-nav__top"
        onClick={scrollToTop}
        aria-label="一番上へ戻る"
      >
        ▲
      </button>
      {towers.map((t) => (
        <button
          type="button"
          key={t}
          data-nav={t}
          className={`tower-jump-nav__btn${active === t ? ' is-active' : ''}`}
          onClick={() => scrollToTower(t)}
          aria-current={active === t ? 'true' : undefined}
        >
          T{t}
        </button>
      ))}
    </nav>
  );
};

export default TowerJumpNav;
